import {
  ADD_APPLICATION_TO_CART_API_REQUEST,
  ADD_APPLICATION_TO_CART_API_SUCCESS,
  ADD_APPLICATION_TO_CART_API_ERROR,
  RESET_ADD_APPLICATION_TO_CART_SUCCESS,
} from '../../../constants/cartActionNames';

import { cartApi } from '../../../apis/cart';

function addApplicationToCartApiRequest() {
  return {
    type: ADD_APPLICATION_TO_CART_API_REQUEST,
    payload: true,
  };
}

function addApplicationToCartApiSuccess(localCart, cart, params) {
  return {
    type: ADD_APPLICATION_TO_CART_API_SUCCESS,
    payload: cart,
    local: localCart,
    params,
  };
}

function addApplicationToCartSuccess(cart, params) {
  return {
    type: ADD_APPLICATION_TO_CART_API_SUCCESS,
    payload: cart,
    params,
  };
}

function addApplicationToCartApiError(err) {
  return {
    type: ADD_APPLICATION_TO_CART_API_ERROR,
    payload: err,
  };
}

export function addApplicationToCartAction(localCartItem, params) {
  return (dispatch, getState) => {
    const state = getState();
    // const { isAuthenticated } = state.auth;
    // if (!isAuthenticated) {
    //  return dispatch(AddApplicationToCartSuccess(localCartItem, params));
    // }
    dispatch(addApplicationToCartApiRequest());
    return cartApi
      .addApplicationToCart(state, params)
      .then(data => {
        dispatch(addApplicationToCartApiSuccess(localCartItem, data, params));
        return data;
      })
      .catch(error => {
        dispatch(addApplicationToCartApiError(error));
        throw error;
      });
  };
}

export default { addApplicationToCartAction };
